import React, { Component } from "react";

import { Button } from "antd";
import { FullscreenOutlined } from "@ant-design/icons";

import { Link } from "react-router-dom";

// Import menuDropdown
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";

//Import logo Images
import logodark from "../../assets/images/logo-dark.png";

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSearch: false,
            isSocialPf: false
        };
        this.toggleFullscreen = this.toggleFullscreen.bind(this);
    }

    toggleFullscreen() {
        if (
            !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
            !document.webkitFullscreenElement
        ) {
            // current working methods
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen(
                    Element.ALLOW_KEYBOARD_INPUT
                );
            }
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            }
        }
    }

    render() {
        return (
            <React.Fragment>
                <header id="page-topbar">
                    <div className="navbar-header">
                        <div className="d-flex">

                            <div className="navbar-brand-box d-flex justify-content-center" >
                                <Link to="#" className="logo logo-dark">
                                    <span className="logo-sm">
                                        <img src={logodark} alt="" height="30" />
                                    </span>

                                    <span className="logo-lg">
                                        <img src={logodark} alt="" height="45" />
                                    </span>
                                </Link>
                            </div>
                        </div>

                        <div
                            className="d-flex"
                            style={{
                                flexWrap: "nowrap",
                                alignItems: "center",
                                flexShrink: 0,
                            }}
                        >
                            <div className="dropdown d-none d-lg-inline-block ms-1">
                                <Button
                                    type="text"
                                    className="header-item noti-icon waves-effect"
                                    onClick={this.toggleFullscreen}
                                    icon={<FullscreenOutlined />}
                                />
                            </div>

                            <ProfileMenu />
                        </div>
                    </div>
                </header>
            </React.Fragment>
        );
    }
}


export default Header;
